import Keycloak, { KeycloakProfile } from "keycloak-js";
import { CONFIG } from "../utils/config.ts";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { ApiError } from "../api";
import { logError } from "../utils/sentry.ts";
import { getPreferredLanguage } from "../locales/utils.ts";

const { AUTH_URL } = CONFIG;

export const keycloak = new Keycloak({
  url: AUTH_URL,
  realm: "multibank",
  clientId: "multibank-openid",
});

export async function keycloakInit() {
  try {
    await keycloak.init({
      onLoad: "check-sso",
      silentCheckSsoRedirectUri: `${location.origin}/silent-check-sso.html`,
      locale: getPreferredLanguage(),
    });
  } catch (error) {
    logError(error);
  }
}

export const USER_QUERY_KEY = "user";

export function useKeycloakUserQuery(
  options?: Omit<UseQueryOptions<KeycloakProfile, ApiError>, "queryFn" | "queryKey">
) {
  return useQuery<KeycloakProfile, ApiError>({
    ...options,
    queryKey: [USER_QUERY_KEY],
    queryFn: async () => {
      if (!keycloak.authenticated) {
        throw new Error("User is not authenticated");
      }
      return await keycloak.loadUserProfile();
    },
    enabled: keycloak.authenticated,
  });
}

